import { render } from "./PrescriptionRegulatoryPlanModal.vue?vue&type=template&id=3d87dda4&scoped=true"
import script from "./PrescriptionRegulatoryPlanModal.vue?vue&type=script&lang=js"
export * from "./PrescriptionRegulatoryPlanModal.vue?vue&type=script&lang=js"

import "./PrescriptionRegulatoryPlanModal.vue?vue&type=style&index=0&id=3d87dda4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d87dda4"]])

export default __exports__